import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const UnlimitedProjects = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.unlimited-projects.title"
                    defaultMessage="Unlimited projects"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.unlimited-projects.bodyOne"
                    defaultMessage="In Jira, a project can be defined as a collection of issues that need to be completed to achieve a certain outcome."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.unlimited-projects.bodyTwo"
                    defaultMessage="To get started, simply choose from a wide selection of <learnMore>project templates</learnMore> based on your team function or use case."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/templates"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.unlimited-projects.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about projects."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/projects/overview#what-are-key-elements"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default UnlimitedProjects;
